var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Details',{attrs:{"currentUserMap":_vm.currentUserMap}}),_c('Footer'),_c('SocialLinks',{attrs:{"noDisplayMobile":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }